<template>
    <PageLoading v-if="isLoading" />
    <div v-else class="main-wrap login-page">
        <div class="login-form column q-col-gutter-y-md justify-center">
            <h1>{{ $t('reset_password.title') }}</h1>
            <div class="tagline">
                {{ $t('reset_password.insert_new_password') }}
            </div>
            <div class="col-12">
                <q-input
                    v-model="user.password"
                    :label="$t('general.password')"
                    :type="isPassword ? 'password' : 'text'"
                    bg-color="black"
                    filled
                    clearable
                    :error-message="passwordErrors"
                    :error="passwordErrors != ''"
                    @input="$v.user.password.$touch()"
                    @blur="$v.user.password.$touch()"
                >
                    <template v-slot:append>
                        <q-icon
                            class="cursor-pointer"
                            :name="isPassword ? 'visibility_off' : 'visibility'"
                            @click="isPassword = !isPassword"
                        />
                    </template>
                </q-input>
            </div>
            <div class="col-12">
                <q-input
                    v-model="user.passwordConfirm"
                    :label="$t('general.password_confirm')"
                    :type="isPasswordConfirm ? 'password' : 'text'"
                    bg-color="black"
                    filled
                    clearable
                    class="q-mb-md"
                    :error-message="passwordConfirmErrors"
                    :error="passwordConfirmErrors != ''"
                    @input="$v.user.passwordConfirm.$touch()"
                    @blur="$v.user.passwordConfirm.$touch()"
                >
                    <template v-slot:append>
                        <q-icon
                            class="cursor-pointer"
                            :name="
                                isPasswordConfirm
                                    ? 'visibility_off'
                                    : 'visibility'
                            "
                            @click="isPasswordConfirm = !isPasswordConfirm"
                        />
                    </template>
                </q-input>
            </div>
            <div class="col">
                <q-btn
                    class="login-btn"
                    :label="$t('actions.reset_password')"
                    text-color="white"
                    flat
                    :loading="isResettingPassword"
                    @click="resetPassword"
                />
            </div>
        </div>
    </div>
</template>

<script>
import validations from '@/views/authentication/mixins/validations'
import PageLoading from '@/components/PageLoading'
import authenticationService from '@/services/authentication'

const loadingKeys = {
    fetchingPage: 'fetching-page',
    resettingPassword: 'resetting-password',
}

export default {
    name: 'ResetPassword',

    components: {
        PageLoading,
    },

    mixins: [validations],

    data() {
        return {
            isPassword: true,
            isPasswordConfirm: true,

            user: {
                password: '',
                passwordConfirm: '',
            },
        }
    },

    computed: {
        isLoading() {
            return this.isResettingPassword
        },

        isResettingPassword() {
            return (
                this.loadings.filter(
                    (loading) => loading.key === loadingKeys.resettingPassword
                ).length > 0
            )
        },
    },

    methods: {
        async resetPassword() {
            this.$v.$touch()

            if (
                this.$v.user.password.$invalid ||
                this.$v.user.password.$invalid ||
                this.isResettingPassword
            ) {
                return true
            }

            this.loadingAdd(loadingKeys.resettingPassword)

            let parameters = {
                data: [
                    {
                        password: this.user.password,
                        token: this.$route.params.token,
                    },
                ],
            }

            let response = await authenticationService.resetPassword(parameters)

            if (response.status === 200) {
                this.$router.push(this.$route.query.redirect || '/')
                this.$q.notify({
                    type: 'positive',
                    message: this.$t(
                        'notify.you_can_now_login_into_your_account'
                    ),
                })
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('errors.send_email_error'),
                })
            }

            this.loadingRemove(loadingKeys.resettingPassword)
        },
    },
}
</script>
